
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, ILegacyLookupService, LocationCodeViewModel, LookupCriteria } from "@tylertech/tyler-api-types";

/**
 * LocationCodeLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class LocationCodeLookupService {
    private readonly $apiService = inject(ApiService);
    
    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<LocationCodeViewModel[]>> {
        return this.$apiService.sendAuth("ILocationCodeLookupService/Lookup", pCriteria);
    }
}
